// extracted by mini-css-extract-plugin
export var Subnavigation = "Subnavigation-module--Subnavigation--6206a";
export var SubnavigationVisible = "Subnavigation-module--Subnavigation--visible--bbc94";